import { motion } from "framer-motion";
import { BRAND } from "../../data/content";
import { Instagram } from "lucide-react";
import useInstagramFeed from "../../hooks/useInstagramFeed";

export default function InstagramFeed() {
  const { loading, live, items } = useInstagramFeed(9);

  return (
    <section className="relative bg-[#FDFBF6] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#C9A961] flex items-center gap-3">
              From the kitchen —
              {live ? (
                <span className="inline-flex items-center gap-1.5 text-[#C9A961]">
                  <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#C9A961] animate-pulse" />
                  Live on Instagram
                </span>
              ) : (
                <span>Latest posts</span>
              )}
            </div>
            <h2 className="mt-6 font-serif font-light text-4xl md:text-5xl leading-[1.05] text-[#3B1F1A]">
              Follow the kitchen.
            </h2>
          </div>
          <a
            href={BRAND.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm text-[#3B1F1A] border-b border-[#C9A961] pb-1 hover:text-[#C9A961]"
          >
            <Instagram size={16} />
            {BRAND.instagramHandle}
          </a>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-6 lg:grid-cols-9 gap-2 md:gap-3">
          {loading &&
            Array.from({ length: 9 }).map((_, i) => (
              <div key={i} className="aspect-square bg-[#F5C9B0]/40 animate-pulse" />
            ))}
          {!loading &&
            items.map((it, i) => (
              <motion.a
                key={it.id}
                href={it.permalink || BRAND.instagram}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: i * 0.04, duration: 0.5 }}
                className="relative aspect-square overflow-hidden group"
                aria-label={it.caption?.slice(0, 80) || "Instagram post"}
              >
                <img
                  src={it.image}
                  alt={it.caption?.slice(0, 80) || "Indian Alchemy Instagram post — luxury event catering Gurugram"}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-[#3B1F1A]/0 group-hover:bg-[#3B1F1A]/45 transition-colors flex items-center justify-center">
                  <Instagram
                    size={20}
                    className="text-[#FDFBF6] opacity-0 group-hover:opacity-100 transition-opacity"
                  />
                </div>
                {it.media_type === "VIDEO" && (
                  <span className="absolute top-2 right-2 text-[9px] uppercase tracking-widest bg-[#3B1F1A]/70 text-[#FDFBF6] px-1.5 py-0.5">
                    Reel
                  </span>
                )}
              </motion.a>
            ))}
        </div>
      </div>
    </section>
  );
}
